/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  // if (typeof content !== 'string') {
  //   content = JSON.stringify(content);
  // }
  window.localStorage.setItem(name, JSON.stringify(content));
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  try {
    return JSON.parse(window.localStorage.getItem(name))
  } catch (e) {
    return null
  }
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}

/**
 * 存储sessionStorage
 */
export const setSession = (name, content) => {
  if (!name) return;
  // if (typeof content !== 'string') {
  //   content = JSON.stringify(content);
  // }
  window.sessionStorage.setItem(name, JSON.stringify(content));
}

/**
 * 获取sessionStorage
 */
export const getSession = name => {
  if (!name) return;
  try {
    return JSON.parse(window.sessionStorage.getItem(name))
  } catch (e) {
    return null
  }
}
/**
 * 删除localStorage
 */
export const removeSession = name => {
  if (!name) return;
  window.sessionStorage.removeItem(name);
}
/**
 *   解决ios单页不能更新title
 **/
export const changeTitle = (title) => {
  var body = document.body;
  document.title = title;
  var iframe = document.createElement("iframe");
  iframe.style.display = 'none';
  iframe.addEventListener('load', function () {
    setTimeout(function () {
      iframe.removeEventListener('load', function () {}, false);
      body.removeChild(iframe);
    }, 0);
  }, false);
  body.appendChild(iframe);
  
}

export const regExp = {
  isMobilePhone(number) {
    return /09\d{8}$/.test(number);
    // return /((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/.test(number);
  },
  isPassPhone(number) {
    return /09\d{8}$/.test(number);
  },
}

var u = navigator.userAgent;

export const browser = {
  // 获取移动终端浏览器版本信息 
  versions: {
    trident: u.indexOf('Trident') > -1, // IE内核
    presto: u.indexOf('Presto') > -1, // opera内核
    webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // IOS终端
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // Android终端或者UC浏览器
    iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为iPhone或者QQ HD浏览器
    iPad: u.indexOf('iPad') > -1, // 是否iPad
    webApp: u.indexOf('Safari') === -1, // 是否web应该程序,没有头部与底部
    phone: (!!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/)) && window.screen.width < 600, // 是否是手机客户端
    pad: (!!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/)) && window.screen.width >= 600
  },
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};



// WEBPACK FOOTER //
// ./src/utils/index.js